export const AI_CURATION_FALLBACK_ERROR =
  "AI was unable to curate this post. Check your provider configuration and try again.";

export const AI_CONNECTION_FALLBACK_ERROR =
  "Failed to contact the configured AI provider. Please try again.";
